import React from 'react'
import img2036 from '../components/images/ialibaba.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2036} alt='alibaba' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Alibaba Account Management (B2B & B2C)
                    </h2>
                    <p>Expand your business reach on Alibaba with our specialized account management services, designed to maximize your success in both B2B and B2C markets. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services We Offer:</h3>
                <li><b>•	Product Listing:</b>Craft compelling product listings to attract buyers and enhance visibility. </li>
                <li><b>•	Advertising Campaign:</b>Launch targeted advertising strategies to expand market reach. </li>
                <li><b>•	Promotion:</b> Drive sales through effective promotional activities and special deals. </li>
                <li><b>•	Brand Registry:</b>Register and protect your brand to build credibility and trust.</li>
                <li><b>•	Brand Approval:</b> Facilitate a seamless brand approval process for new products. </li>
                <li><b>•	Category Approval:</b> Ensure products are accurately categorized to optimize searchability.</li>
                <li><b>•	Account Health:</b>Maintain a healthy account status to avoid suspensions and issues. </li>
                <li><b>•	Order Processing:</b> Streamline order management for efficient fulfillment and delivery. </li>
                <li><b>•	Payment Reconciliation:</b>Handle payment processing accurately to resolve any issues. </li>
                <li><b>•	Keyword Optimization:</b> Enhance visibility with strategic keyword placement. </li>
                <li><b>•	Safety Compliance:</b> Ensure compliance with Alibaba’s product safety and regulatory standards. </li>
                <li><b>•	Basic Training:</b>Provide essential training to manage your Alibaba account effectively. </li>
                <li><b>•	Sales Boost:</b> Implement strategies to boost sales and expand your market presence.</li>
            </ul>
        </>
    )
}

export default events